import type { ComponentProps } from "react";
import { Link } from "wouter";
import { publicNavigationHref } from "@/lib/public-navigation-href";

/** Use the same destination before hydration and after client navigation. */
export function PublicNavigationLink({ href, to, ...props }: ComponentProps<typeof Link>) {
  return <Link {...props} href={publicNavigationHref(href ?? to ?? "", import.meta.env.BASE_URL)} />;
}
